import {  AreaChartOutlined, ArrowRightOutlined, CheckCircleTwoTone, ClockCircleFilled, ClockCircleTwoTone, CreditCardFilled, CreditCardOutlined, DeleteOutlined, DoubleRightOutlined, EnterOutlined, LineChartOutlined, MailOutlined, MonitorOutlined, QrcodeOutlined, RightCircleFilled, RightCircleOutlined, SearchOutlined, SettingOutlined, ShareAltOutlined, StarFilled, StarOutlined, TagFilled, TagOutlined, UserOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Badge, Card, Input, Progress, Tag, Typography } from 'antd';
import { useMemo, useState } from 'react';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import TableLZM from '../../../components/design/table/TableLZM';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import { LocationCardCompacted } from '../../../components/model/business/FieldsGroup';
import { SpinLZ } from '../../../components/design/Spinner/SpinLZ';
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import SelectPeriod from '../../../components/model/selectMonths/SelectPeriod';
import { QRDrawer } from './QRDrawer';
import { QRMonitoringLabelsDrawer } from './QRMonitoringLabelsDrawer';
import { HistoricQRScansDrawer } from './HistoricQRScansDrawer';
import { CSVDownload } from '../../../../common/utils/CSVDownload';
import { ModuleAccessGate } from '../../common/roles/ModuleAccessGate';
import { PageTitle } from '../../common/PageTitle';
import { PageFilters, PageFilterField } from '../../common/PageFilters';
const { Paragraph } = Typography;

const QR_PAGE_INFO = 'Esta funcionalidad es un soporte a estrategias que buscan el aumento de reseñas de clientes, en particular ayuda a medir y monitorizar el número de escaneos que se hace a un QR determinado. Para eso proporcionamos links a través de los que podemos dejar una reseña en un local pero con la ventaja que permiten el conteo posterior, estos links además se pueden asociar por ejemplo a empleados para entender la contribución de cada uno de ellos de forma individual.';

export const QRLocations = () => (
	<ModuleAccessGate module='QR_ANALYTICS' title='Solicitar Reseñas' pageInfo={QR_PAGE_INFO}>
		<QRLocationsContent />
	</ModuleAccessGate>
);

const QRLocationsContent = () => {	
	
	const [isLoading, setIsLoading] = useState(true);

	const { projectGroup } = useAuth();		
	
	const [locations, setLocations] = useState<any[]>([]);
	const [locationQRDrawer, setLocationQRDrawer] = useState<any>(null);
	const [locationMonitoringConfigDrawer, setLocationMonitoringConfigDrawer] = useState(null);
	const [locationHistoricQRScans, setLocationHistoricQRScans] = useState(null);
	const [updateData, setUpdateData] = useState(false);	
	const [selectedType, setSelectedType] = useState('LAST_3MONTHS');

	useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/locations/card?filterPeriod=${selectedType}`, {}, [updateData], 	
	(data) => { 
		setIsLoading(true);
		setLocations(data || []);	
		setIsLoading(false);
	});

	const totals = useMemo(() => {
		const configuredLocations = locations.filter(
			(location) => Object.keys(location.monitoringQRMap || {}).length > 0
		);
		const totalScans = locations.reduce(
			(sum, location) => sum + Number(location.numberOfScans || 0),
			0
		);
		const totalCards = locations.reduce(
			(sum, location) => sum + Object.keys(location.monitoringQRMap || {}).length,
			0
		);
		return {
			totalScans,
			totalCards,
			configuredLocations: configuredLocations.length,
			totalLocations: locations.length,
		};
	}, [locations]);

	const columns: any = [						
		{
			title: 'Establecimientos',
			key: 'location',			
			width: '300px',						
			sorter: (a: any, b: any) => a.locality?.localeCompare(b.locality),
			filterDropdown: ({
			  setSelectedKeys,
			  selectedKeys,
			  confirm,			  
			}: FilterDropdownProps) => {
			  return (
				<Input
				  autoFocus
				  //placeholder="Filtro"
				  value={selectedKeys[0]}
				  onChange={(e: any) => {
					setSelectedKeys(e.target.value ? [e.target.value] : []);
					confirm({ closeDropdown: false });
				  }}
				  onPressEnter={() => {
					confirm();
				  }}
				  onBlur={() => {
					confirm();
				  }}
				></Input>
			  );
			},
			filterIcon: () => {
			  return <SearchOutlined />;
			},
			onFilter: (value: any, record: any) => {
				return record.title?.toLowerCase().includes(value?.toLowerCase()) 
				|| record.administrativeArea?.toLowerCase().includes(value?.toLowerCase())
				|| record.locality?.toLowerCase().includes(value?.toLowerCase());
			},
			render: (text: string, record: any) => (								
				<LocationCardCompacted location={record} />																								
			),
		},	
		{
			title: 'Tarjetas Activas',
			key: 'emlpoyees',
			width: '300px',
			//dataIndex: 'numberOfReviews',
			//align: 'center',			
			render: (text: string, record: any) => {
				const cards = Object.entries(record.monitoringQRMap || {});
				const configureButton = (
					<button
						type='button'
						onClick={() => setLocationMonitoringConfigDrawer(record)}
						style={{
							display: 'inline-flex',
							alignItems: 'center',
							gap: 5,
							padding: 0,
							border: 'none',
							background: 'transparent',
							color: '#595959',
							fontSize: 12,
							fontWeight: 500,
							cursor: 'pointer',
						}}
					>
						<SettingOutlined style={{ fontSize: 12 }} />
						Configurar tarjetas QR
					</button>
				);

				if (!cards.length) {
					return configureButton;
				}

				return (
				<>
					{cards.map(([qrId, employee]: any) => {
				const shareUrl = `${process.env.REACT_APP_API}/public/writereview?p=${record.placeId}&c=${qrId}`;
				
				return (
					<div key={qrId} style={{
						display: 'grid',
						gridTemplateColumns: '1fr 180px 80px', 
						alignItems: 'center',
						gap: '15px',
						padding: '10px 15px',
						margin: '8px 0',
						backgroundColor: 'white', // Fondo sutil para separar filas
						borderRadius: '12px',			
						border: '1px solid #f0f0f0'
					}}>
						{/* COLUMNA 1: IDENTIFICACIÓN (FLEX) */}
						<div style={{ 
							display: 'inline-flex', // Hace que el contenedor ocupe solo el ancho de su contenido
							alignItems: 'center', 
							gap: '12px', 
							whiteSpace: 'nowrap', // Evita que el texto salte de línea
							flexWrap: 'nowrap'    // Fuerza que todo se mantenga en una fila
						}}>
							<Tag color='white' style={{ 
								color: 'slategrey', 
								borderRadius: '20px', 
								border: 'solid 1px slategrey', 
								margin: 0,
								display: 'flex',
								alignItems: 'center',
								gap: '4px'
							}}>
								<CreditCardFilled /> tarjeta {qrId}
							</Tag>
							
							<span style={{ color: '#8c8c8c', fontSize: '12px', fontStyle: 'italic' }}>
								vinculada a
							</span>
							
							<Tag 
								color='Lavender' 
								style={{ 
									color:'black',
									//border:'1px solid slategrey',
									margin: 0,
									display: 'inline-flex',   // Cambiado a inline-flex para mejor comportamiento de Tag
									alignItems: 'center', 
									justifyContent: 'center', // Centro horizontal (ya que usas minWidth)
									textAlign: 'center',
									height: '24px',           // Altura fija opcional para asegurar consistencia
									gap: '6px',
									lineHeight: '1',          // Vital: evita que el texto se "caiga"
									padding: '0 8px'          // Ajusta el aire interno
								}}
							>
								<UserOutlined style={{ display: 'flex' }} /> 
								<span style={{ marginTop: '-1px' }}>{employee?.name}</span> 
							</Tag>
						</div>

						{/* COLUMNA 2: COPIAR LINK (FLEX CENTRADO) */}
						<div style={{ 
							display: 'flex', 
							alignItems: 'center', 
							justifyContent: 'flex-start',
							borderLeft: '1px solid #e8e8e8',
							paddingLeft: '15px'
						}}>
							<small style={{ color: 'slategrey', marginRight: '5px' }}>Link para dejar reseña</small>
							<Paragraph 
								style={{ margin: 0 }} 
								copyable={{ text: shareUrl }}
							/>
						</div>

						{/* COLUMNA 3: ACCIONES (GRID O FLEX ALINEADO AL FINAL) */}
						<div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
							<ButtonLZ 
								type='link' 
								onClick={() => setLocationQRDrawer({ location: record, url: shareUrl })} 
								size='small'
								style={{ padding: 0 }}
							> 
								<div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
									<small style={{ color: 'slategrey', marginRight: '5px'}}>Ver QR </small><QrcodeOutlined style={{ fontSize: '24px' }} />
								</div>
							</ButtonLZ>
						</div>
					</div>
				);
			})}
					<div style={{ marginTop: 2 }}>
						{configureButton}
					</div>
				</>
			);
			}			
		},
		{
			title: 'Métricas de Escaneo',
			key: 'scansAndHistory',
			width: '180px',
			align: 'center',
			sorter: (a: any, b: any) => Number(a.numberOfScans || 0) - Number(b.numberOfScans || 0),
			defaultSortOrder: 'descend' as const,
			render: (_: any, record: any) => {
				const hasQRs = Object.keys(record.monitoringQRMap || {}).length > 0;
				if (!hasQRs) return null;

				return (
					<div style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						gap: '8px',
						margin: '0 auto'
					}}>
						<div style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: 'white',
							border: '1px solid #d9d9d9',
							borderRadius: '8px',
							padding: '8px 16px',
							minWidth: '130px',
							boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
						}}>
							<span style={{ 
								fontSize: '22px', 
								fontWeight: '800', 
								color: 'black', 
								lineHeight: '1.2'
							}}>
								{record.numberOfScans?.toLocaleString() || 0}
							</span>
							<span style={{ 
								fontSize: '10px', 
								fontWeight: '600',
								color: 'slategrey', 
								textTransform: 'uppercase',
								letterSpacing: '0.5px'
							}}>
								escaneos de qr
							</span>
						</div>
						<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
							<ButtonLZ 
								type='primary' 
								onClick={() => setLocationHistoricQRScans(record)} 
								size='small'
								style={{ 
									borderRadius: '4px', 
									fontSize: '11px',
									display: 'flex',
									alignItems: 'center',
									gap: '5px',
									height: '24px'
								}}
							>
								<LineChartOutlined /> Ver histórico
							</ButtonLZ>
						</div>
					</div>
				);
			}
		}			
	]

  	return (
		<>			
			<Card className='main-card-content'>

				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems:'center', marginBottom:'0px' }}>
					<PageTitle
						title='Solicitar Reseñas'
						pageInfo={QR_PAGE_INFO}
						extra={
							<PageFilters>
								<PageFilterField label='Periodo'>
									<SelectPeriod setSelectedType={setSelectedType} defaultValue={selectedType} maxMonths={12}/>
								</PageFilterField>
							</PageFilters>
						}
					/>
				</div>								                								
				{isLoading ? 
					<SpinLZ/> 
					: 
					<div>
						{locations.length > 0 && (
							<div style={{
								display: 'grid',
								gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
								gap: 16,
								margin: '8px 0 16px',
							}}>
								<div style={{
									background: 'white',
									borderRadius: 16,
									padding: '12px 16px',
									border: '1px solid #e2e8f0',
								}}>
									<div style={{ fontSize: 11, color: '#9F9F9F', fontWeight: 500 }}>Total escaneos</div>
									<div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6 }}>
										<QrcodeOutlined style={{ fontSize: 20, color: '#7b93a8' }} />
										<span style={{ fontSize: 26, fontWeight: 700, color: '#475569', lineHeight: 1 }}>
											{totals.totalScans.toLocaleString()}
										</span>
									</div>
								</div>
								<div style={{
									background: 'white',
									borderRadius: 16,
									padding: '12px 16px',
									border: '1px solid #e2e8f0',
								}}>
									<div style={{ fontSize: 11, color: '#9F9F9F', fontWeight: 500 }}>Tarjetas activas</div>
									<div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6 }}>
										<CreditCardOutlined style={{ fontSize: 20, color: '#7b93a8' }} />
										<span style={{ fontSize: 26, fontWeight: 700, color: '#475569', lineHeight: 1 }}>
											{totals.totalCards.toLocaleString()}
										</span>
									</div>
								</div>
								<div style={{
									background: 'white',
									borderRadius: 16,
									padding: '12px 16px',
									border: '1px solid #e2e8f0',
								}}>
									<div style={{ fontSize: 11, color: '#9F9F9F', fontWeight: 500 }}>Locales configurados</div>
									<div style={{ marginTop: 6 }}>
										<span style={{ fontSize: 26, fontWeight: 700, color: '#475569', lineHeight: 1 }}>
											{totals.configuredLocations.toLocaleString()}
										</span>
										<span style={{ fontSize: 13, color: '#94a3b8', marginLeft: 6 }}>
											/ {totals.totalLocations.toLocaleString()}
										</span>
									</div>
								</div>
							</div>
						)}
						{locations.length > 0 &&						
							<TableLZM 
								rowKey='location'								
								columns={columns}
								dataSource={locations}
								loading={false}/>
						}				
					</div>
				}								
				{locations.length > 0 && <CSVDownload dataSource={transformarDatos(locations)} title="Descargar CSV" fileName={`Datos de escaneos de QR.csv`}/>			}
			</Card>
			{locationQRDrawer && <QRDrawer location={locationQRDrawer.location} url={locationQRDrawer.url} onFinish={() => {setLocationQRDrawer(null);}} />}
			{locationMonitoringConfigDrawer && <QRMonitoringLabelsDrawer location={locationMonitoringConfigDrawer} onUpdate={() => {setUpdateData(!updateData);}} onFinish={() => {setLocationMonitoringConfigDrawer(null);}} />}										
			{locationHistoricQRScans && <HistoricQRScansDrawer location={locationHistoricQRScans} onFinish={() => {setLocationHistoricQRScans(null);}} />}										
		</>
			
	)	
}

const transformarDatos = (datos: any): any[] => {	

	return datos.map((dato : any) => ({
		'Nombre': dato.title,
		'Localidad': dato.locality,
		'Áream Administrativa': dato.administrativeArea,
		'Dirección': dato.addressLine,
		'Número de escaneos': dato.numberOfScans,
		'Número de tarjetas': Object.keys(dato.monitoringQRMap).length,		
	}));
  };
